(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["occasion-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('occasion-product-slider')) {
    customElements.define(
      'occasion-product-slider',
      class OccasionProductSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-occasion-track]');
          this.previousButton = this.querySelector('[data-direction="previous"]');
          this.nextButton = this.querySelector('[data-direction="next"]');

          if (!this.track || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', () => this.scrollProducts(-1));
          this.nextButton.addEventListener('click', () => this.scrollProducts(1));
          this.track.addEventListener('scroll', () => this.requestControlUpdate(), { passive: true });

          this.resizeObserver = new ResizeObserver(() => this.updateControls());
          this.resizeObserver.observe(this.track);
          this.updateControls();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        scrollProducts(direction) {
          const item = this.track.querySelector('.occasion-slider__item');
          const styles = window.getComputedStyle(this.track);
          const gap = Number.parseFloat(styles.columnGap) || 16;
          const distance = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth * 0.85;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.track.scrollBy({
            left: distance * direction,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        }

        requestControlUpdate() {
          if (this.controlFrame) return;
          this.controlFrame = window.requestAnimationFrame(() => {
            this.controlFrame = null;
            this.updateControls();
          });
        }

        updateControls() {
          const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          this.previousButton.disabled = this.track.scrollLeft <= 2;
          this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
